import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import {
  sendRequest,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import TasksListNewTasks from '../../../../../components/Tasks/TasksListNewTasks';

class ChosenTasksList extends Component {
  constructor(props) {
    super(props);
    this.props.changeDefaultQueryParams({
      page: 1,
      sort: '-created_at'
    });
    this.props.sendRequest();
  }

  render() {
    return <TasksListNewTasks reducerName={this.props.listReduceName} />;
  }
}

ChosenTasksList.defaultProps = {
  queryParamsStatic: {}
};

ChosenTasksList.propTypes = {
  // IN
  listReduceName: PropTypes.string.isRequired,

  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

ChosenTasksList.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChosenTasksList)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/ChosenTasksList/ChosenTasksList.js